// extracted by mini-css-extract-plugin
export default {"Paragraph":"Paragraph1iuH19jhdHkt","Paragraph_Placeholder":"Paragraph_Placeholder1ViKRnS-xAMb","Paragraph_PlaceholderIcon":"Paragraph_PlaceholderIcon2VmYgykIacYc"};